export default "__VITE_ASSET__c5d18622__"